import React from "react";
import { Languages, ChevronDown } from "lucide-react";
import hero_logo from "../assets/header_logo.png";
import { useI18n } from "../i18n/I18nProvider";

export default function Navbar() {
  const { locale, setLocale, t } = useI18n();

  const languageButtonClasses = (targetLocale) =>
    `inline-flex items-stretch rounded-full border border-ekatraLightBlue overflow-hidden shadow-sm bg-transparent max-h-[32px] sm:max-h-[36px] ${
      locale === targetLocale ? "" : "opacity-70"
    }`;

  return (
    <header className="w-full bg-ekatraOrange shadow-sm">
      <div className="px-4 md:px-12 py-3 md:py-4 flex items-center justify-between">
        {/* ================= LEFT LOGO ================= */}
        <div className="flex items-center gap-3 cursor-pointer">
          <img src={hero_logo} className="w-6 h-6 z-10" />
          <div className="flex flex-col leading-tight">
            <span className="text-[15px] md:text-[20px] uppercase tracking-[0.25em] text-ekatraBlue font-medium">
              {t("navbar.brand")}
            </span>
          </div>
        </div>

        {/* ================= MIDDLE MENU ================= */}
        <nav className="hidden md:flex gap-4 xl:gap-8 text-ekatraBlue font-medium text-[15px]">
          <a href="#home" className="relative hover:opacity-70 scroll-smooth">
            {t("navbar.home")}
            <span className="block h-[2px] w-full bg-ekatraBlue mt-1 rounded-full"></span>
          </a>
          <a href="#about" className="hover:opacity-70 scroll-smooth">
            {t("navbar.about")}
          </a>
          <a href="#books" className="hover:opacity-70 scroll-smooth">
            {t("navbar.books")}
          </a>
          <a href="#features" className="hover:opacity-70 scroll-smooth">
            {t("navbar.features")}
          </a>
          <a href="#categories" className="hover:opacity-70 scroll-smooth">
            {t("navbar.categories")}
          </a>
        </nav>

        {/* ================= RIGHT CONTROLS ================= */}
        <div className="flex items-center gap-2 md:gap-3">
          {/* Language selector pill with icon segment + label segment */}
          <button
            type="button"
            onClick={() => setLocale("en")}
            className={languageButtonClasses("en")}
            aria-pressed={locale === "en"}
          >
            <div className="flex items-center justify-center bg-ekatraLightBlue text-[#F1AF38] px-2 sm:px-4 py-1.5 sm:py-2">
              <Languages
                className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                strokeWidth={2.2}
              />
            </div>
            <div className="flex items-center gap-1 sm:gap-2 px-2 sm:px-4 py-1.5 sm:py-2 bg-[#F1AF38] text-ekatraLightBlue">
              <span className="text-[11px] sm:text-[14px] font-medium leading-none">
                {t("navbar.english")}
              </span>
            </div>
          </button>

          <button
            type="button"
            onClick={() => setLocale("gu")}
            className={languageButtonClasses("gu")}
            aria-pressed={locale === "gu"}
          >
            <div className="flex items-center justify-center bg-ekatraLightBlue text-[#F1AF38] px-2 sm:px-4 py-1.5 sm:py-2">
              <Languages
                className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                strokeWidth={2.2}
              />
            </div>
            <div className="flex items-center gap-1 sm:gap-2 px-2 sm:px-4 py-1.5 sm:py-2 bg-[#F1AF38] text-ekatraLightBlue">
              <span className="text-[11px] sm:text-[14px] font-medium leading-none">
                {t("navbar.gujarati")}
              </span>
            </div>
          </button>
        </div>
      </div>
    </header>
  );
}
